import * as React from 'react';

import { Bem } from '../../service/Bem/Bem';
import { UrlHelpers } from '../../service/UrlHelpers';
import { Shape2, Shape2Icon } from '../Shape2/Shape2';
import { RouteStyledLink } from '../StyledLink/StyledLink';

import './FreelancerLinkCell.css';

export interface FreelancerLinkCellProps {
    ulogin: string;
    freelancerLogin: string;
}

const BLOCK = 'freelancer-link-cell';

export class FreelancerLinkCell extends React.PureComponent<FreelancerLinkCellProps> {
    render() {
        const { ulogin, freelancerLogin } = this.props;

        return (
            <RouteStyledLink cls={Bem.cls(BLOCK)} href={UrlHelpers.getFreelancerCardUrl(ulogin, freelancerLogin)}>
                <Shape2 icon={Shape2Icon.link2} width={16} height={15} />
            </RouteStyledLink>
        );
    }
}
